import CryptoJS from 'crypto-js'; // 引用AES源码js

var key = CryptoJS.enc.Utf8.parse('frx8o1p9mn5ci8mj'); // 十六位十六进制数作为密钥
// var iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412'); // 十六位十六进制数作为密钥偏移量

// 解密方法
function decrypt(_word) {
    // var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    // var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    // var decrypt = CryptoJS.AES.decrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    // var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    // return decryptedStr.toString();
    var parsedWordArray = CryptoJS.enc.Base64.parse(_word);
    var word = parsedWordArray.toString(CryptoJS.enc.Utf8);
    var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    var decrypt = CryptoJS.AES.decrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);

    return decryptedStr.toString();

}

// 加密方法
function encrypt(word) {
    // var srcs = CryptoJS.enc.Utf8.parse(word);
    // var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    // var hexStr = encrypted.ciphertext.toString();
    // var oldHexStr = CryptoJS.enc.Hex.parse(hexStr);
    // // 将密文转为Base64的字符串
    // return CryptoJS.enc.Base64.stringify(oldHexStr);

    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    var result = encrypted.ciphertext.toString().toUpperCase();

    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(result));

}

export default {
    decrypt,
    encrypt
};
